<form [formGroup]="form">
  <div class="fields-wrapper">
    <app-select
      label="Colors"
      placeholder="Choose colors"
      [multipleValue]="getColorsValue()"
      [options]="getColorsOptions()"
      color="secondary"
      [multiple]="true"
      [errorMessage]="errorMessages.colors"
      (optionSelected)="onColorOptionSelect(formControls.colors, $event, formControls.defaultColor)"
    ></app-select>
    <app-text-field
      ngDefaultControl
      formControlName="defaultColor"
      label="Default color index"
      [value]="formControls.defaultColor.value"
    ></app-text-field>
  </div>
  <div *ngFor="let color of getSelectedColors()" class="images-fields-wrapper">
    <span class="color-name">{{ color }}</span>
    <div class="fields-wrapper">
      <app-text-field
        ngDefaultControl
        [formControlName]="color + '1'"
        label="First image url"
        [value]="formControls[color + '1']?.value"
        [errorMessage]="getUrlErrorMessages(color + '1')"
      ></app-text-field>
      <app-text-field
        ngDefaultControl
        [formControlName]="color + '2'"
        label="Second image url"
        [value]="formControls[color + '2']?.value"
        [errorMessage]="getUrlErrorMessages(color + '2')"
      ></app-text-field>
    </div>
  </div>
</form>
